import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errorMessage } from "../../lib/api";
import { Field, TextArea } from "../forms/Fields";

const Answer = ({ r }) => (
  <article className="bg-paper rounded-2xl p-6" data-testid={`research-${r.id}`}>
    <p className="font-display text-xl">{r.question}</p>
    <p className="mt-3 whitespace-pre-wrap text-[15px] leading-relaxed">{r.answer}</p>
    {r.citations?.length > 0 && (
      <>
        <p className="lbl mt-5 text-slate">Sources</p>
        <ol className="mt-2 list-decimal pl-5 space-y-1 text-sm">
          {r.citations.map((u) => <li key={u}><a href={u} target="_blank" rel="noreferrer" className="text-teal underline break-all">{u}</a></li>)}
        </ol>
      </>
    )}
    <p className="mt-4 text-xs text-slate">AI-generated summary. Check sources before relying on it.</p>
  </article>
);

export const ResearchPanel = () => {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/research").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const ask = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/admin/research", { question: q }); setItems((xs) => [data, ...xs]); setQ(""); }
    catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <div className="font-sans space-y-8 max-w-4xl" data-testid="admin-research">
      <form onSubmit={ask} className="bg-paper rounded-2xl p-6 space-y-4" aria-label="Research question" data-testid="research-form">
        <p className="font-display text-2xl">Research helper</p>
        <p className="text-slate text-sm">Ask a question and get a short answer with sources, e.g. "Latest research on Visual Phonics and reading outcomes".</p>
        <Field id="rq" label="Your question" required><TextArea id="rq" rows={3} required minLength={3} value={q} onChange={(e) => setQ(e.target.value)} /></Field>
        <button type="submit" disabled={busy} className="inline-flex items-center gap-2 bg-teal text-paper rounded-full px-6 py-3 hover:bg-teal-deep disabled:opacity-70" data-testid="research-submit-button">
          {busy && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}{busy ? "Researching..." : "Research"}
        </button>
      </form>
      {items.map((r) => <Answer key={r.id} r={r} />)}
    </div>
  );
};
